// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__db6L5","hasBackgroundImage":"Hero_hasBackgroundImage__BcWG1"};